<template>
  <div>
    <CCard>
      <CCardHeader>
        <h2>休暇申請詳細</h2>
      </CCardHeader>
      <CCardBody>
        <CAlert v-if="errorMessage" color="danger">{{ errorMessage }}</CAlert>
        <ValidationObserver ref="obs">
          <CRow>
            <div class="container">
              <table class="table">
                <tr><th scope="row">申請日</th><td>{{ updated_at }}</td></tr>
                <tr><th scope="row">プロジェクト名</th><td>{{ project_name }}</td></tr>
                <tr><th scope="row">種別</th><td><span>{{ getTypeName(type) }}</span></td></tr>
                <tr><th scope="row">開始日</th><td>{{ formatDate(start_day) }}【{{ getDayName(start_time) }}】</td></tr>
                <tr>
                  <th scope="row">終了日</th>
                  <td>{{ endLabel }}</td>
                </tr>
                <tr><th scope="row">備考・事由など</th><td>{{ reason }}</td></tr>
                <tr><th scope="row">連絡先(電話番号等)</th><td>{{ telephone }}</td></tr>
                <tr>
                  <th scope="row">事前承認済</th>
                  <td>
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center mb-2">
                        <label class="custom-switch mb-0">
                          <input type="checkbox" class="custom-switch-input" id="mgr-approved" v-model="manager_approval" disabled>
                          <span class="custom-switch-indicator" aria-hidden="true"></span>
                        </label>
                        <label for="mgr-approved" class="ml-2 mb-0">弊社上長</label>
                      </div>
                      <div class="d-flex align-items-center">
                        <label class="custom-switch mb-0">
                          <input type="checkbox" class="custom-switch-input" id="sup-approved" v-model="supervisor_approval" disabled>
                          <span class="custom-switch-indicator" aria-hidden="true"></span>
                        </label>
                        <label for="sup-approved" class="ml-2 mb-0">現場上長（お客様含む）</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <router-link :to="{ name: paidAndSudstituteList }">
                    <button class="btn btn-secondary">戻る</button>
                  </router-link>
                </CCol>
                <CCol class="text-center">
                  <router-link :to="{ name: paidAndSudstituteEdit, params: { id: $route.params.id } }">
                    <button class="btn btn-info">編集</button>
                  </router-link>
                </CCol>
                <CCol></CCol>
              </CRow>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import axios from 'axios'
import ConstList from '../../ConstList'
import { safeErrorDigest } from '../../utils/safeResponseMessage'

export default {
  name: 'PaidAndSubstitute',
  data () {
    return {
      updated_at: '',
      project_name: '',
      type: '',
      type_options: [
        { id: ConstList.PAID_ID, name: ConstList.PAID_NAME },
        { id: ConstList.SUBSTITUTE_ID, name: ConstList.SUBSTITUTE_NAME },
        { id: ConstList.SPECIAL_ID, name: ConstList.SPECIAL }
      ],
      start_day: '',
      start_time: '',
      end_day: '',
      end_time: '',
      days: [
        { id: ConstList.ALLDAY_ID, name: ConstList.ALLDAY },
        { id: ConstList.MORNING_ID, name: ConstList.MORNING },
        { id: ConstList.AFTERNOON_ID, name: ConstList.AFTERNOON }
      ],
      reason: '',
      telephone: '',
      approval_type: '',
      manager_approval: false,
      supervisor_approval: false,
      errorMessage: '',
      paidAndSudstituteList: ConstList.ROUTE_PAIDANDSUDSTITUTE_LIST,
      paidAndSudstituteEdit: ConstList.ROUTE_PAIDANDSUDSTITUTE_EDIT
    }
  },
  computed: {
    endLabel () {
      if (this.end_day != null && this.end_time != null &&
          (this.start_day !== this.end_day || this.start_time !== this.end_time)) {
        return `${this.formatDate(this.end_day)}【${this.getDayName(this.end_time)}】`
      }
      return '単日取得'
    }
  },
  mounted () {
    const id = Number(this.$route.params.id)
    if (!Number.isSafeInteger(id) || id <= 0) {
      this.errorMessage = '休暇申請を特定できません。'
      return
    }
    axios
      .get(`${process.env.VUE_APP_API_ORIGIN}/paidandsubstitute/${id}`)
      .then(response => {
        if (!response.data) {
          this.errorMessage = ConstList.EMPTY
          return
        }
        const userData = response.data
        this.project_name = userData.project_name
        this.start_day = userData.start_day
        this.start_time = userData.start_time
        this.end_day = userData.end_day
        this.end_time = userData.end_time
        this.type = userData.type
        this.updated_at = userData.updated_at
        this.reason = userData.reason
        this.telephone = userData.telephone
        this.approval_type = userData.approval_type
        this.manager_approval = [ConstList.MANAGER_APPROVAL_ID, ConstList.BOTH_APPROVAL_ID].includes(this.approval_type)
        this.supervisor_approval = [ConstList.SUPERVISOR_APPROVAL_ID, ConstList.BOTH_APPROVAL_ID].includes(this.approval_type)
      })
      .catch(error => {
        this.errorMessage = '休暇申請を取得できませんでした。'
        console.error('休暇申請詳細取得失敗:', safeErrorDigest(error))
      })
  },
  methods: {
    getTypeName (id) {
      const option = this.type_options.find(value => value.id === id)
      return option ? option.name : id
    },
    formatDate (dateStr) {
      if (!dateStr) return ''
      const [yyyy, mm, dd] = dateStr.split('-')
      return `${yyyy}/${mm}/${dd}`
    },
    getDayName (id) {
      const option = this.days.find(value => value.id === id)
      return option ? option.name : id
    }
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
.container {
  margin-left: 0%;
}
</style>
